'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".BlockButton-module_button__0m7W2{background-color:#2b7cac;border:.0625rem #2b7cac;border-radius:.125rem;color:#fff;cursor:pointer;display:inline-block;font-family:inherit;font-size:.875rem;font-weight:700;height:auto;line-height:1.25rem;margin:0;min-width:6.25rem;padding:.625rem 1.5rem;position:relative;text-align:center;-webkit-text-decoration:none;text-decoration:none}.BlockButton-module_buttonOutline__tN-gZ{background-color:transparent;border:1px solid #2b7cac;color:#2b7cac}";
var styles = {"button":"BlockButton-module_button__0m7W2","buttonOutline":"BlockButton-module_buttonOutline__tN-gZ"};
styleInject["default"](css_248z, '7d725b24-aa9d-4312-91a6-b9fcef10045c');

exports["default"] = styles;
